import { render, staticRenderFns } from "./Festivities.vue?vue&type=template&id=dec05298&scoped=true&"
import script from "./Festivities.vue?vue&type=script&lang=js&"
export * from "./Festivities.vue?vue&type=script&lang=js&"
import style0 from "./Festivities.vue?vue&type=style&index=0&id=dec05298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec05298",
  null
  
)

export default component.exports